import React from "react";
import Typography from "@material-ui/core/Typography";
import { SubmitButton } from "../components/Buttons/SubmitButton";
import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@material-ui/core/Grid";
import { Container } from "../components/Container";

const ErrorPage: React.FC = () => {
  const { logout, error } = useAuth0();

  const errorMessage = error?.message || "An unexpected authentication error occurred";

  const handleRetryLogin = () => {
    logout();
  };

  return (
    <Container className="bg-black-900 h-screen flex items-center justify-center">
      <Grid container spacing={4} justify="center" alignItems="center" style={{ minHeight: "60vh" }}>
        <Grid item xs={12} md={8}>
          <div className="text-center">
            <Typography variant="h3" component="h1" gutterBottom style={{ color: "#f04e23", fontWeight: "bold" }}>
              Authentication Error
            </Typography>
            <Typography variant="h6" component="p" gutterBottom style={{ marginTop: "1rem", color: "#666" }}>
              {errorMessage}
            </Typography>
            <Typography variant="body1" component="p" style={{ marginTop: "1rem", color: "#999" }}>
              There was a problem with the authentication process. This could be due to:
            </Typography>
            <ul style={{ textAlign: "left", display: "inline-block", marginTop: "1rem", color: "#999" }}>
              <li>Session expired or invalid</li>
              <li>Network connectivity issues</li>
              <li>Authentication service temporarily unavailable</li>
              <li>Invalid or revoked credentials</li>
            </ul>
            <Typography variant="body1" component="p" style={{ marginTop: "1.5rem", color: "#999" }}>
              Please try logging in again. If the problem persists, contact support.
            </Typography>
            <div className="mt-8 flex justify-center">
              <SubmitButton
                isSubmitting={false}
                isValid={true}
                handleSubmit={handleRetryLogin}
                type="button"
                label="Try Login Again"
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ErrorPage;
